import { useIsMobile } from "../../../hooks/useMobile";
import DashboardSurveyList from "../components/dashboard-survey-list.component";
import DashboardSurveyTable from "../components/dashboard-survey-table.component";
import { useNavigate } from "react-router-dom";
import useCreateNewSurvey from "src/hooks/useCreateNewSurvey";

const SurveysTab = () => {
  const { isMobile } = useIsMobile();
  const { createNewSurvey } = useCreateNewSurvey();
  const navigate = useNavigate();
  return (
    <>
      {isMobile ? <DashboardSurveyList /> : <DashboardSurveyTable />}
    </>
  );
};

export default SurveysTab;
